module.exports = __webpack_public_path__ + "static/media/pic2.f25f70ae.png";